export const PRODUCT_NAME = 'Complete AAC Communication Toolkit™';
export const PRODUCT_PRICE = 26.9;
export const CHECKOUT_URL = 'https://complete-aac-communication-toolkit.impultienda.ar/checkout';
export const OFFER_ANCHOR = '#offer';
export const META_PIXEL_ID = '1822734912085445';
export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/pUYn2nzW5RseQRN68cgZha/Kit_completo_de_comunicacion_AAC.png';
export const SUPPORT_EMAIL = 'compradigitalyaa@gmail.com';

// Editable footer links — replace "#" with your real legal page URLs.
export const FOOTER_LINKS = [
  { label: 'Terms & Conditions', href: '#' },
  { label: 'Privacy Policy', href: '#' },
  { label: 'Contact', href: `mailto:${SUPPORT_EMAIL}` },
];

export const formatPrice = (value: number) => `$${value.toFixed(2)}`;
